import React, { useState, useRef, useEffect } from 'react';
import { API_BASE } from '../api';
import { useNavigate, Link } from 'react-router-dom';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    newJoinerName: '', location: '', newJoinerPhone: '',
    newJoinerEmailId: '', reportingManager: '', position: 'FSE', dob: ''
  });
  const [photo, setPhoto]       = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [cvFile, setCvFile]     = useState(null);
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState('');
  const [loading, setLoading]   = useState(false);
  const [camOpen, setCamOpen]   = useState(false);
  const videoRef  = useRef();
  const canvasRef = useRef();
  const streamRef = useRef();
  const [tlList, setTlList] = useState([]);

useEffect(() => {
  fetch(`${API_BASE}/api/tl/approved-list`)
    .then(r => r.json())
    .then(data => setTlList(Array.isArray(data) ? data : []))
    .catch(() => {});
}, []);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  // Automatically compress image before upload (converts to JPEG ~300KB max)
  const compressImage = (file, maxWidth = 1000, quality = 0.7) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (!blob) {
              resolve(file);
              return;
            }
            resolve(new File([blob], file.name.replace(/\.[^/.]+$/, "") + ".jpg", { type: 'image/jpeg' }));
          }, 'image/jpeg', quality);
        };
      };
    });
  };

  const setPhotoFile = async (file) => {
    if (!file) return;
    // Compress if larger than 500 KB
    const finalFile = file.size > 500 * 1024 ? await compressImage(file) : file;
    
    setPhoto(finalFile);
    const reader = new FileReader();
    reader.onload = (e) => setPhotoPreview(e.target.result);
    reader.readAsDataURL(finalFile);
  };

const openCamera = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: false
    });

    streamRef.current = stream;
    setCamOpen(true);

  } catch (err) {
    console.log(err);
    alert('Camera error: ' + err.message);
  }
};
useEffect(() => {
  if (!camOpen) return;

  if (videoRef.current && streamRef.current) {
    videoRef.current.srcObject = streamRef.current;
  }
}, [camOpen]);

  const capture = () => {
  const canvas = canvasRef.current;
  const video  = videoRef.current;

  if (!canvas || !video) return; // safety

  canvas.width  = video.videoWidth;
  canvas.height = video.videoHeight;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(video, 0, 0);

  canvas.toBlob(blob => {
    if (!blob) return;

    setPhotoFile(
      new File([blob], 'photo-' + Date.now() + '.jpg', {
        type: 'image/jpeg'
      })
    );

    stopCamera();
  }, 'image/jpeg', 0.7);
};
  const stopCamera = () => {
  if (streamRef.current) {
    streamRef.current.getTracks().forEach(track => track.stop());
    streamRef.current = null;
  }
  setCamOpen(false);
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    const nameRegex = /^[a-zA-Z\s]+$/;
    if (!nameRegex.test(form.newJoinerName)) { setError('Name should contain letters only'); return; }
    // if (!nameRegex.test(form.reportingManager)) { setError('Reporting Manager name should contain letters only'); return; }

    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(form.newJoinerPhone)) { setError('Phone number must be exactly 10 digits'); return; }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.newJoinerEmailId)) { setError('Please enter a valid email address'); return; }

    // if (form.password !== form.confirmPassword) { setError('Passwords do not match'); return; }
    if (!photo) { setError('Profile photo is required'); return; }
    if (photo.size > 3 * 1024 * 1024) { setError('Profile photo is too large. Please select an image under 3 MB.'); return; }
    if (cvFile && cvFile.size > 3 * 1024 * 1024) { setError(`CV file size is too large (${(cvFile.size / (1024 * 1024)).toFixed(1)} MB). Please upload a PDF/DOC under 3 MB.`); return; }

    // const fd = new FormData();
    // const submitForm = { ...form, email: form.newJoinerEmailId };
    // Object.entries(submitForm).forEach(([k, v]) => { if (k !== 'confirmPassword') fd.append(k, v); });

    // fd.append('photo', photo);
    // if (cvFile) fd.append('cv', cvFile);

    // setLoading(true);
    // try {
    //   const res  = await fetch(`${API_BASE}/api/auth/register`, { method: 'POST', body: fd });
    const fd = new FormData();

if (form.position === 'TL') {
  // TL field names match TeamLead model
  fd.append('email',            form.newJoinerEmailId);
  fd.append('name',             form.newJoinerName);
  fd.append('phone',            form.newJoinerPhone);
  fd.append('emailId',          form.newJoinerEmailId);
  fd.append('reportingManager', form.reportingManager);
  fd.append('location',         form.location);
  fd.append('dob',              form.dob);
} else {
  // FSE — existing logic unchanged
  const submitForm = { ...form, email: form.newJoinerEmailId };
  Object.entries(submitForm).forEach(([k, v]) => { if (k !== 'confirmPassword') fd.append(k, v); });
}

fd.append('photo', photo);
if (cvFile) fd.append('cv', cvFile);

const endpoint = form.position === 'TL' ? '/api/tl/register' : '/api/auth/register';


setLoading(true);
try {
  const res = await fetch(`${API_BASE}${endpoint}`, { method: 'POST', body: fd });

      const data = await res.json();
      if (!res.ok) { setError(data.message || 'Registration failed'); return; }
      setSuccess('✓ Registration successful! Redirecting to login...');
      setTimeout(() => navigate('/'), 2000);
    } catch { setError('Server error. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card" style={{ maxWidth: 520 }}>
        <div className="auth-logo">
          <img src="/logo-full.png" alt="Synchronous Build Digital" />
          <span className="tagline">Digital &amp; Technology Solutions</span>
        </div>
        <hr className="auth-divider" />
        <h2>New Joiner Registration</h2>
        <p className="subtitle">Synchronous Build Digital – New Joining Candidate Details</p>

        {error   && <div className="error-msg"   style={{ display: 'block' }}>{error}</div>}
        {success && <div className="success-msg" style={{ display: 'block' }}>{success}</div>}

        <form onSubmit={handleSubmit}>
          {/* <div className="form-group">
            <label>Email Address <span className="req">*</span></label>
            <input type="email" value={form.email} onChange={set('email')} placeholder="your@email.com" required />
          </div> */}

          {/* Photo upload */}
          <div className="form-group">
            <label>Profile Photo <span className="req">*</span></label>
            <div className="photo-upload-box">
              <div className="photo-preview-wrap">
                <div className="photo-preview" style={photoPreview ? { backgroundImage: `url(${photoPreview})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}>
                  {!photoPreview && '👤'}
                </div>
              </div>
              <div className="photo-actions">
  <button type="button" className="photo-btn" onClick={openCamera}>
    📷 Take Photo
  </button>

  <label className="photo-btn">
    🖼 Choose from Gallery
    <input
      type="file"
      accept="image/*"
      style={{ display: 'none' }}
      onChange={e => e.target.files[0] && setPhotoFile(e.target.files[0])}
    />
  </label>
</div>

{/* 🔥 ADD THIS BELOW
{camOpen && (
  <div style={{ marginTop: '15px', textAlign: 'center' }}>
    <video
      ref={videoRef}
      autoPlay
      playsInline
      style={{
        width: '220px',
        borderRadius: '12px',
        border: '2px solid #2e7d32'
      }}
    />

    <br />

    <button
      type="button"
      onClick={capture}
      style={{
        marginTop: '10px',
        padding: '8px 15px',
        background: '#2e7d32',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer'
      }}
    >
      📸 Capture
    </button>
  </div>
)} */}
              <div className="file-name">{photo ? photo.name : 'No photo selected'}</div>
            </div>
          </div>

          {/* CV upload */}
          <div className="form-group">
            <label>Upload CV <span className="req">*</span></label>
            <div className="file-upload-box">
              <label className="file-label">
                📄 Add File <small style={{ fontWeight: 400, color: '#888' }}>(PDF/DOC · Max 3 MB)</small>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={e => {
                    const file = e.target.files[0];
                    if (file && file.size > 3 * 1024 * 1024) {
                      setError(`CV file is too large (${(file.size / (1024 * 1024)).toFixed(1)} MB). Max allowed is 3 MB.`);
                      return;
                    }
                    setError('');
                    setCvFile(file || null);
                  }}
                />
              </label>
              <div className="file-name">{cvFile ? cvFile.name : 'No file chosen'}</div>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>New Joiner Name <span className="req">*</span></label>
              <input type="text" value={form.newJoinerName} onChange={set('newJoinerName')} placeholder="Full name" required />
            </div>
            <div className="form-group">
              <label>Location <span className="req">*</span></label>
              <input type="text" value={form.location} onChange={set('location')} placeholder="City / Office" required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Phone Number <span className="req">*</span></label>
              <input type="tel" value={form.newJoinerPhone} onChange={e => setForm(f => ({ ...f, newJoinerPhone: e.target.value.replace(/\D/g, '').slice(0, 10) }))} placeholder="+91 XXXXX XXXXX" required />

            </div>
            <div className="form-group">
              <label>Joiner Email ID <span className="req">*</span></label>
              <input type="email" value={form.newJoinerEmailId} onChange={set('newJoinerEmailId')} placeholder="joiner@email.com" required />
            </div>
          </div>
            <div className="form-row">
  <div className="form-group">
    <label>Date of Birth <span className="req">*</span></label>
    <input type="date" value={form.dob} onChange={set('dob')} required />
  </div>
  <div className="form-group">
    <label>Reporting Manager <span className="req">*</span></label>
    <select value={form.reportingManager} onChange={set('reportingManager')} required>
      <option value="">-- Select TL --</option>
      {tlList.map(tl => (
        <option key={tl._id} value={tl.name}>{tl.name}</option>
      ))}
    </select>
  </div>
</div>
<input type="hidden" value="FSE" name="position" />

          

          <button type="submit" className="btn" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit Registration'}
          </button>
        </form>

        <div className="auth-link">
          Already registered? <Link to="/">Sign in here</Link>
        </div>
      </div>

      {/* Camera Modal */}
      {camOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
          <video ref={videoRef} autoPlay playsInline style={{ width: '100%', maxWidth: 420, borderRadius: 12 }} />
          <div style={{ display: 'flex', gap: 12 }}>
            <button onClick={capture} style={{ padding: '12px 28px', background: '#0284c7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>📷 Capture</button>
            <button onClick={stopCamera} style={{ padding: '12px 28px', background: '#555', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, cursor: 'pointer' }}>Cancel</button>
          </div>
          <canvas ref={canvasRef} style={{ display: 'none' }} />
        </div>
      )}
    </div>
  );
}
